import script from "./ChatInputComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatInputComponent.vue?vue&type=script&setup=true&lang=ts"

import "./ChatInputComponent.vue?vue&type=style&index=0&id=e7de4cf2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7de4cf2"]])

export default __exports__